import React from 'react';
export function SiteFooter() {
  return <footer className="border-t border-gold-500/15 bg-void-950 py-14" data-id="element-191" data-mp="1dqrohw3lfk7t">
      <div className="mx-auto max-w-3xl px-6 text-center" data-id="element-192" data-mp="3r9aqdijkxq0s">
        <p className="neon-text-soft font-display text-xl font-light text-gold-400" data-id="element-193" data-mp="3mhj7zvakuqlq">
          ¿Estás listo para jugar?
        </p>
        <p className="mx-auto mt-7 max-w-2xl text-xs leading-relaxed text-bone-500" data-id="element-194" data-mp="3hheqq31uhrug">
          Este eBook es una guía de reflexión y crecimiento personal. No sustituye ningún tipo de
          tratamiento médico, psicológico ni terapéutico. Los resultados dependen de la
          disposición, el contexto y la práctica personal de cada lector.
        </p>
        <p className="mt-6 text-xs text-bone-500" data-id="element-195" data-mp="33khz3zdwk6ci">
          © 2026 ¿Estás listo para jugar? · Todos los derechos reservados.
        </p>
      </div>
    </footer>;
}